import { type ComponentPropsWithoutRef, type ComponentRef, type Ref } from 'react'
import * as PopoverPrimitive from '@radix-ui/react-popover'

import cn from '@components/utils/cn'

import { overlayContentClass } from './overlayContentStyles'

const Popover = PopoverPrimitive.Root
const PopoverTrigger = PopoverPrimitive.Trigger

const PopoverContent = ({
  align = 'center',
  sideOffset = 4,
  portal = false,
  className,
  ref,
  ...props
}: ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
  ref?: Ref<ComponentRef<typeof PopoverPrimitive.Content>>
  // Off by default: the portal traps focus when mounted in the v1 interface.
  portal?: boolean
}) => {
  const content = (
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(overlayContentClass, 'tw:relative tw:w-fit', className)}
      {...props}
    />
  )

  return portal ? (
    <PopoverPrimitive.Portal>
      <div className="tailwind">{content}</div>
    </PopoverPrimitive.Portal>
  ) : (
    content
  )
}

export { Popover, PopoverTrigger, PopoverContent }
